<p-confirmdialog></p-confirmdialog>

<div class="delegacias-container p-4">
    @if (carregandoVisualizacao) {
        <div class="flex justify-center items-center py-8 min-h-[160px]">
            <p-progressSpinner aria-label="Carregando visualização da delegacia"></p-progressSpinner>
        </div>
    } @else if (delegaciaSelecionada) {
        <section class="delegacia-detalhe">
            <div class="delegacia-detalhe-inner">
                <div class="delegacia-detalhe-layout">
                    <!-- ═══════════════════════════════════════════
                         COLUNA ESQUERDA — Identificação (sticky)
                    ═══════════════════════════════════════════ -->
                    <div class="coluna-config">
                        <!-- ─ Identidade ─ -->
                        <app-card-content [border]="false" [headerColor]="false" [title]="delegaciaSelecionada.delegacia" [subtitle]="'Delegacia Regional'" [icon]="'pi pi-building'">
                            <p-button label="Voltar" icon="pi pi-arrow-left" styleClass="p-button-outlined" [size]="'small'" (click)="voltarParaLista()" card-header />

                            <div class="flex items-center justify-between gap-2">
                                <div class="flex items-center gap-2 min-w-0">
                                    <p-badge
                                        [severity]="(delegaciaSelecionada.situacao || '').toUpperCase() === 'ATIVO' || (delegaciaSelecionada.situacao || '').toUpperCase() === 'FUNCIONANDO' ? 'success' : 'danger'"
                                        [value]="delegaciaSelecionada.situacao"
                                        badgeSize="large"
                                    ></p-badge>
                                    <p-tag [value]="delegaciaSelecionada.uf" severity="info" styleClass="text-[11px]"></p-tag>
                                </div>
                                <div class="flex justify-end gap-2 flex-shrink-0">
                                    <ng-container *appPermissao="'mesmaUf'; valor: delegaciaSelecionada.uf">
                                        <p-button
                                            icon="pi pi-trash"
                                            (click)="confirmarExclusaoDelegacia(delegaciaSelecionada)"
                                            severity="danger"
                                            [text]="true"
                                            [rounded]="true"
                                            pTooltip="Excluir"
                                            [appCan]="PERMISSOES.orgaos.delegacias.excluir"
                                            [appCanUf]="delegaciaSelecionada.uf"
                                        />
                                        <p-button label="Editar" icon="pi pi-pencil" severity="primary" (click)="abrirEdicaoDelegacia(delegaciaSelecionada)" [appCan]="PERMISSOES.orgaos.delegacias.editar" [appCanUf]="delegaciaSelecionada.uf" />
                                    </ng-container>
                                </div>
                            </div>
                        </app-card-content>

                        <!-- ─ Identificação ─ -->
                        <div class="card-entrada card-entrada-1">
                            <app-card-content [border]="false" [headerColor]="false" [title]="'Identificação'" [subtitle]="'Dados cadastrais da delegacia'" [icon]="'pi pi-id-card'">
                                <div class="flex flex-col gap-4">
                                    <div class="field">
                                        <label class="font-semibold block mb-1.5 text-xs text-slate-400 dark:text-slate-500 uppercase tracking-wider">CNPJ</label>
                                        <div class="p-3 bg-slate-50 dark:bg-slate-800 rounded-lg border border-slate-100 dark:border-slate-700 flex items-center gap-2">
                                            <i class="pi pi-id-card text-blue-500"></i>
                                            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ valorOuTraco(formatarCnpj(delegaciaSelecionada.cnpj)) }}</span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label class="font-semibold block mb-1.5 text-xs text-slate-400 dark:text-slate-500 uppercase tracking-wider">Sigla</label>
                                        <div class="p-3 bg-slate-50 dark:bg-slate-800 rounded-lg border border-slate-100 dark:border-slate-700 flex items-center gap-2">
                                            <i class="pi pi-bookmark text-indigo-500"></i>
                                            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ valorOuTraco(delegaciaSelecionada.sigla) }}</span>
                                        </div>
                                    </div>

                                    <div class="p-3 bg-blue-50/50 dark:bg-blue-950/20 border border-blue-100 dark:border-blue-900/50 rounded-lg flex items-center gap-3 text-xs text-blue-700 dark:text-blue-300">
                                        <i class="pi pi-info-circle text-sm"></i>
                                        <div class="flex flex-col">
                                            <span
                                                >Atualizado em: <strong>{{ formatarDataAtualizacao(delegaciaSelecionada.dataAtualizacao) }}</strong></span
                                            >
                                            <span
                                                >Por: <strong>{{ valorOuTraco(delegaciaSelecionada.usuario) }}</strong></span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </app-card-content>
                        </div>
                    </div>

                    <!-- ═══════════════════════════════════════════
                         COLUNA DIREITA — Dados
                    ═══════════════════════════════════════════ -->
                    <div class="coluna-conteudo">
                        <div class="card-entrada card-entrada-1">
                            <app-card-content [border]="true" [headerColor]="false" title="Informações Adicionais" icon="pi pi-info-circle">
                                <div card-header class="aba-switcher">
                                    <button type="button" class="aba-btn" [class.aba-ativa]="abaDetalheAtiva === '0'" (click)="abaDetalheAtiva = '0'">Contato</button>
                                    <button type="button" class="aba-btn" [class.aba-ativa]="abaDetalheAtiva === '1'" (click)="abaDetalheAtiva = '1'">Composição</button>
                                    <button type="button" class="aba-btn" [class.aba-ativa]="abaDetalheAtiva === '2'" (click)="abaDetalheAtiva = '2'">Abrangência</button>
                                </div>

                                <div class="pt-4">
                                    @if (abaDetalheAtiva === '0' && pessoaDelegaciaSelecionada) {
                                        <app-contato
                                            [appCan]="PERMISSOES.orgaos.contato.escopo"
                                            [appCanUf]="delegaciaSelecionada.uf"
                                            [pessoa]="pessoaDelegaciaSelecionada"
                                            [usarEndpointsDelegacia]="true"
                                            [iniciarComoCard]="true"
                                            [roleEditarContato]="'orgaos.contato.editar'"
                                            [roleExcluirContato]="'orgaos.contato.excluir'"
                                            (dadosAtualizados)="notificarDadosAtualizados()"
                                        ></app-contato>
                                    }
                                    @if (abaDetalheAtiva === '1' && pessoaDelegaciaSelecionada) {
                                        <app-composicao
                                            [appCan]="PERMISSOES.orgaos.composicao.escopo"
                                            [appCanUf]="delegaciaSelecionada.uf"
                                            [uf]="delegaciaSelecionada.uf"
                                            [pessoa]="pessoaDelegaciaSelecionada"
                                            [usarEndpointsDelegacia]="true"
                                            (dadosAtualizados)="notificarDadosAtualizados()"
                                        ></app-composicao>
                                    }
                                    @if (abaDetalheAtiva === '2') {
                                        <div class="abrangencia-container">
                                            @if (carregamentoInicialAbrangencias()) {
                                                <div class="flex justify-center items-center py-8 min-h-[120px]">
                                                    <p-progressSpinner aria-label="Carregando abrangência da delegacia"></p-progressSpinner>
                                                </div>
                                            }

                                            <app-card-content icon="pi pi-map" title="Abrangência">
                                                <div card-header>
                                                    <ng-container *appPermissao="'mesmaUf'; valor: delegaciaSelecionada.uf">
                                                        <p-button label="Adicionar Município" icon="pi pi-plus-circle" (click)="abrirAdicionarMunicipio()" [appCan]="PERMISSOES.orgaos.abrangencia.criar" [appCanUf]="delegaciaSelecionada.uf"></p-button>
                                                    </ng-container>
                                                </div>

                                                <app-custom-table
                                                    [data]="abrangencias"
                                                    [metadata]="abrangenciasMetadata()"
                                                    [columnOrder]="abrangenciasColumnOrder"
                                                    [showActions]="true"
                                                    [loading]="carregandoAbrangencias"
                                                    [showExpandButton]="false"
                                                    [initialViewMode]="initialViewMode()"
                                                    [rows]="10"
                                                    [totalRecords]="abrangencias.length"
                                                    [permissaoUf]="delegaciaSelecionada.uf"
                                                >
                                                </app-custom-table>
                                            </app-card-content>
                                        </div>
                                    }
                                </div>
                            </app-card-content>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    }
</div>

<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Dados e abrangência da delegacia." [header]="tituloDialogDelegacia" [(visible)]="displayDelegaciaDialog" [style]="{ width: '680px', maxWidth: '95vw' }">
    <form [formGroup]="formDelegacia" class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        <div class="flex flex-col gap-1.5">
            <label for="delegaciaUf" class="font-semibold">UF *</label>
            <input id="delegaciaUf" pInputText formControlName="uf" class="w-full" readonly />
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaSigla" class="font-semibold">Sigla *</label>
            <input id="delegaciaSigla" pInputText formControlName="sigla" class="w-full" maxlength="10" />
        </div>

        <div class="md:col-span-2 flex flex-col gap-1.5">
            <label for="delegaciaDescricao" class="font-semibold">Delegacia *</label>
            <input id="delegaciaDescricao" pInputText formControlName="descricao" class="w-full" maxlength="150" />
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaCnpj" class="font-semibold">CNPJ *</label>
            <p-inputMask id="delegaciaCnpj" mask="99.999.999/9999-99" formControlName="registro" class="w-full"></p-inputMask>
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaSituacao" class="font-semibold">Situação *</label>
            <p-select id="delegaciaSituacao" [options]="situacoes" formControlName="situacao" optionLabel="label" optionValue="value" placeholder="Selecione a situação" class="w-full" appendTo="body"></p-select>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-3 pt-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" (click)="displayDelegaciaDialog = false"></p-button>
            <p-button [label]="labelBotaoSalvarDelegacia" icon="pi pi-check" [loading]="salvandoDelegacia" (click)="salvarDelegacia()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Município que passa a integrar a abrangência." header="Adicionar Município" [(visible)]="displayMunicipioDialog" [style]="{ width: '620px', maxWidth: '95vw' }">
    <form [formGroup]="formMunicipio" class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        <div class="flex flex-col gap-1.5">
            <label for="abrangenciaUf" class="font-semibold">UF *</label>
            <input id="abrangenciaUf" pInputText formControlName="uf" class="w-full" readonly />
        </div>

        <div class="md:col-span-2 flex flex-col gap-1.5">
            <label for="abrangenciaMunicipio" class="font-semibold">Município *</label>
            <select id="abrangenciaMunicipio" formControlName="idMunicipio" class="p-inputtext p-component w-full">
                <option value="">Selecione o município</option>
                @for (municipio of municipiosDisponiveis(); track municipio.id) {
                    <option [value]="municipio.id">{{ municipio.dsMunicipio }}</option>
                }
            </select>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-3 pt-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" (click)="displayMunicipioDialog = false"></p-button>
            <p-button label="Adicionar" icon="pi pi-check" [loading]="salvandoMunicipio" (click)="salvarMunicipio()"></p-button>
        </div>
    </ng-template>
</p-dialog>
